import Vue from 'vue';
import Vuetify, { VDialog, VNavigationDrawer } from 'vuetify/lib';
import Overlayable from 'vuetify/lib/mixins/overlayable';
import 'vuetify/dist/vuetify.min.css';
import whitelabel from '../whitelabel-config';

const light = whitelabel(process.env.VUE_APP_BRAND).colors;

function walkScrollCheckThroughShadowRootsAndStopAtDocument(component) {
  const { methods } = component.options;
  const { shouldScroll } = methods;
  methods.shouldScroll = function (el, e) {
    if (el instanceof ShadowRoot) return this.shouldScroll(el.host, e);
    if (!(el instanceof Element)) return false;
    return shouldScroll.call(this, el, e);
  };
}

[Overlayable, VDialog, VNavigationDrawer].forEach(
  walkScrollCheckThroughShadowRootsAndStopAtDocument
);

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light,
    },
  },
  typography: {
    font: {
      family: 'Montserrat, sans-serif',
    },
  },
};

export default new Vuetify(opts);
